<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('school.academic.operation.classOperation.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('school.academic.operation.classOperation.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-whitespace-no-wrap ts-justify-between">
          <ts-button
            color="info"
            outline
            @click="$router.push({ name: 'class-operation-create' })"
            >{{ $t('add_new') }}</ts-button
          >
          <div class="d-flex">
            <div class="ts-mr-2">
              <a-radio-group button-style="solid" v-model="isHasEnrollment">
                <a-radio-button>
                  {{ $t('school.academic.operation.classOperation.all') }}
                </a-radio-button>
                <a-radio-button :value="0">
                  {{ $t('school.academic.operation.classOperation.empty') }}
                </a-radio-button>
                <a-radio-button :value="1">
                  {{
                    $t('school.academic.operation.classOperation.enrollment')
                  }}
                </a-radio-button>
              </a-radio-group>
            </div>
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
            <a-drawer
              :title="$t('filter')"
              placement="right"
              :closable="false"
              :visible="visible"
              @close="() => (visible = false)"
              :zIndex="1020"
              width="300px"
            >
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>{{
                      $t('school.academic.operation.classOperation.branch')
                    }}</label>
                    <a-select
                      style="width: 257px"
                      v-model="branch_id"
                      :options="branchs"
                      showSearch
                      mode="multiple"
                      :filterOption="
                        (input, option) =>
                          option.componentOptions.children[0].text
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                      "
                      :maxTagCount="1"
                      :maxTagTextLength="17"
                      :placeholder="$t('all')"
                    >
                    </a-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>{{
                      $t(
                        'school.academic.operation.classOperation.academicYear'
                      )
                    }}</label>
                    <a-select
                      style="width: 257px"
                      v-model="acYearIdFilter"
                      :options="acYearList"
                      showSearch
                      mode="multiple"
                      :filterOption="
                        (input, option) =>
                          option.componentOptions.children[0].text
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                      "
                      :maxTagCount="1"
                      :maxTagTextLength="17"
                      :placeholder="$t('all')"
                    >
                    </a-select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>
                      {{
                        $t('school.academic.operation.classOperation.status')
                      }}
                    </label>
                    <a-select
                      class="ts-w-full"
                      v-model="status"
                      mode="multiple"
                    >
                      <a-select-option :value="1">{{
                        $t('classoperation.current')
                      }}</a-select-option>
                      <a-select-option :value="2">{{
                        $t('classoperation.history')
                      }}</a-select-option>
                      <a-select-option :value="3">{{
                        $t('classoperation.next')
                      }}</a-select-option>
                    </a-select>
                  </div>
                </div>
              </div>
            </a-drawer>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-loading-banner :loading="exporting">
          <Table
            row-key="index"
            :columns="columns"
            :data="groupResources"
            size="small"
            :loading="loading"
            :span-method="handleSpan"
            highlight-row
            stripe
            max-height="700"
          >
            <template slot-scope="{ row }" slot="branch_name_en">
              {{ row.branch ? row.branch.branch_name_en : '' }}
            </template>
            <template slot-scope="{ row }" slot="students_count">
              <span
                class="ts-bg-teal-300 ts-rounded-full ts-px-1 ts-font-semibold ts-text-center"
                >{{ row.students_count }}</span
              >
            </template>
            <template slot-scope="{ row }" slot="grade_name_foreign">
              {{ row.grade ? row.grade.grade_name_foreign : '' }}
            </template>
            <template slot-scope="{ row }" slot="room_name">
              {{ row.room ? row.room.room_name : '' }}
            </template>
            <template slot-scope="{ row }" slot="term_name">
              {{ row.academic_term ? row.academic_term.term_name : '' }}
            </template>
            <template slot-scope="{ row }" slot="full_name_en">
              {{ row.teacher ? row.teacher.full_name_en : '' }}
            </template>
            <template slot-scope="{ row }" slot="ac_year">
              {{ row.academic_year ? row.academic_year.ac_year : '' }}
            </template>
            <template slot-scope="{ row }" slot="ac_status_id">
              <span class="label label-green" v-if="row.ac_status_id == 1"
                >current</span
              >
              <span class="label label-secondary" v-if="row.ac_status_id == 2"
                >history</span
              >
              <span class="label label-info" v-if="row.ac_status_id == 3"
                >next</span
              >
            </template>
            <template slot-scope="{ row }" slot="name_en">
              {{ row.created_by.employee.name_en }}
            </template>
            <template slot-scope="{ row }" slot="name_en">
              {{ row.modified_by ? row.modified_by.employee.name_en : '' }}
            </template>
            <template slot-scope="{ row }" slot="action">
              <a
                href="#"
                class="mr-2 text-primary"
                v-tooltip="
                  $t('school.academic.operation.classOperation.student')
                "
                @click.prevent="showStudentList(row)"
              >
                <i class="fas fa-users"></i>
              </a>
              <a
                href="#"
                class="mr-2 text-primary"
                @click.prevent="edit(row)"
                v-tooltip="$t('edit')"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                class="text-info ts-mr-2"
                @click.prevent="copyClass(row)"
                :disabled="row._deleting"
                v-tooltip="$t('copy')"
              >
                <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                <i class="fas fa-copy" v-else></i>
              </a>
              <a
                href="#"
                class="text-danger"
                @click.prevent="destroy(row)"
                :disabled="row._deleting"
                v-tooltip="$t('delete')"
              >
                <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </template>
          </Table>
        </ts-loading-banner>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- view student list -->
      <a-modal
        v-model="show_student_list"
        centered
        @ok="() => (show_student_list = false)"
        :zIndex="1020"
        :cancelText="$t('cancel')"
        :okText="$t('ok')"
        :footer="null"
        width="50%"
      >
        <template v-slot:title>
          <div class="ts-flex ts-justify-between ts-items-baseline">
            <div>
              <h2>
                {{ $t('school.academic.operation.classOperation.studentList') }}
              </h2>
            </div>
            <div class="ts-pr-4">
              <div class="ts-flex">
                <h4>{{ classInfo.class_name }} |</h4>
                <h4>{{ classInfo.teacher_name }} |</h4>
                <h4>{{ classInfo.study_time }}</h4>
              </div>
            </div>
          </div>
        </template>
        <student-list :student="student_lists" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>

import { debounce } from 'lodash'
import { mapState } from 'vuex'
import StudentList from './components/view-student-list'
import iTable from '@/store/i-table-helper'

export default {
  name: 'classOperation',
  components: {
    StudentList
  },
  data () {
    return {
      visible: false,
      loading: false,
      all_year: false,
      show_student_list: false,
      exporting: false,
      student_lists: [],
      classInfo: {},
      branchs: []
    }
  },
  created () {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  computed: {
    ...mapState('classOperation', ['resources', 'pagination']),
    groupResources () {
      return iTable.rowGroup(this.resources, 'sub_program.acps_name_foreign')
    },
    acYearList () {
      return this.$store.state.classOperation.yearList.map(el => ({
        value: el.ac_year_id,
        label: el.ac_year
      }))
    },
    search: {
      get () {
        return this.$store.state.classOperation.search
      },
      set (newValue) {
        this.$store.commit('classOperation/SET_SEARCH', newValue)
        this.$store.commit('classOperation/RESET_CURRENT_PAGE')
      }
    },
    branch_id: {
      get () {
        return this.$store.state.classOperation.branch_id
      },
      set (newValue) {
        this.$store.commit('classOperation/SET_BRANCH_ID', newValue)
      }
    },
    acYearIdFilter: {
      get () {
        return this.$store.state.classOperation.acYearFilter
      },
      set (newValue) {
        this.$store.commit('classOperation/SET_ACYEAR_ID_FILTER', newValue)
      }
    },
    isHasEnrollment: {
      get () {
        return this.$store.state.classOperation.isHasEnrollment
      },
      set (newValue) {
        this.$store.commit('classOperation/SET_HAS_ENROLMENT_FILTER', newValue)
      }
    },
    columns () {
      return [
        {
          key: 'column_name',
          tree: true,
          maxWidth: 15,
          className: 'text-primary bold'
        },
        {
          title: this.$t('school.academic.operation.classOperation.branch'),
          minWidth: 190,
          slot: 'branch_name_en'
        },
        {
          title: this.$t('school.academic.operation.classOperation.className'),
          minWidth: 190,
          key: 'class_name'
        },
        {
          title: this.$t('school.academic.operation.classOperation.student'),
          minWidth: 180,
          slot: 'students_count',
          align: 'center',
        },
        {
          title: this.$t('school.academic.operation.classOperation.grade'),
          minWidth: 180,
          slot: 'grade_name_foreign'
        },
        {
          title: this.$t('school.academic.operation.classOperation.room'),
          minWidth: 180,
          slot: 'room_name'
        },
        {
          title: this.$t('school.academic.operation.classOperation.term'),
          minWidth: 180,
          slot: 'term_name'
        },
        {
          title: this.$t('school.academic.operation.classOperation.teacher'),
          minWidth: 120,
          slot: 'full_name_en'
        },
        {
          title: this.$t(
            'school.academic.operation.classOperation.description'
          ),
          minWidth: 120,
          key: 'class_desc'
        },
        {
          title: this.$t(
            'school.academic.operation.classOperation.academicYear'
          ),
          minWidth: 130,
          slot: 'ac_year'
        },
        {
          title: this.$t('school.academic.operation.classOperation.status'),
          minWidth: 100,
          slot: 'ac_status_id',
          align: 'center'
        },
        {
          title: this.$t(
            'school.academic.operation.classOperation.createdDate'
          ),
          minWidth: 160,
          key: 'created_date'
        },
        {
          title: this.$t('school.academic.operation.classOperation.createdBy'),
          minWidth: 120,
          slot: 'name_en'
        },
        {
          title: this.$t(
            'school.academic.operation.classOperation.modifiedDate'
          ),
          minWidth: 160,
          key: 'modified_date'
        },
        {
          title: this.$t('school.academic.operation.classOperation.modifiedBy'),
          minWidth: 120,
          slot: 'name_en'
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 150
        }
      ]
    },
    status: {
      get () {
        return this.$store.state.classOperation.ac_status_id
      },
      set (newValue) {
        this.$store.commit('classOperation/SET_STATUS_ID', newValue)
      }
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'classOperation/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getBranch () {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    edit (record) {
      this.$store.commit('classOperation/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'class-operation-edit',
        params: { id: record.class_id }
      })
    },
    async destroy (record) {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        record._deleting = true
        this.$store
          .dispatch('classOperation/destroy', record.class_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    async copyClass (record) {
      this.$store.commit('classOperation/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'class-operation-copy-class',
        params: { id: record.class_id }
      })
    },
    showStudentList (record) {
      this.show_student_list = true
      this.classInfo = {
        class_name: record.class_name,
        teacher_name: record.teacher ? record.teacher.full_name_en : '',
        study_time: record.academic_study_time.study_time
      }
      this.student_lists = record.students
    },
    handleSpan ({ row, column, rowIndex, columnIndex }) {
      return iTable.handleSpan(row, columnIndex, this.columns)
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search, branch_id: this.branch_id })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500),
    status: debounce(function () {
      this.fetchData({ branch_id: this.branch_id })
    }, 500),
    acYearIdFilter: debounce(function () {
      this.fetchData({ branch_id: this.branch_id })
    }, 500),
    isHasEnrollment: debounce(function () {
      this.fetchData({ branch_id: this.branch_id })
    }, 500)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.dispatch('classOperation/getAcademicYear')
      vm.$store.dispatch('classOperation/getListClass')
    })
  }
}
</script>
<style lang="css">
  .bold{
    font-weight: bold;
   
  }
</style>
